<div class="error-page">
    <div class="wrap">
        <span class="info-text">Tato stránka neexistuje</span>
        <div class="error-code">
            404
        </div>
        <span class="links">
            <a (click)="goBack()">Vrátit se na zpět</a>
            <a routerLink="/landingPage">Vrátit se na úvod</a>
        </span>
    </div>
</div>